import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const BadgeLazy = loadable(() => import(/* webpackChunkName: "Badge" */ './BadgeSuspense'));

export const BadgeAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <BadgeLazy />
    </DelayedSuspense>
);
